import type { CallStatusResourceResponseApi } from '@ingenico/api-sdk-device-management-private';
import type { GridCallbackDetails, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import type { GridApiPremium } from '@mui/x-data-grid-premium';
import type { GridRowParams } from '@mui/x-data-grid-pro';
import type { MutableRefObject } from 'react';
import { useMemo } from 'react';
import type { DeviceCallLogsGridProps } from '../logicalDeviceHistoryTab.model';

export function useGridPropsSetup({
  handleRowClick,
  datagridRef,
  total,
  getRowId,
  isLoading,
  shouldDisplayGrid,
  onPaginationModelChange,
  onSortModelChange,
}: {
  readonly handleRowClick: ({ row }: GridRowParams<CallStatusResourceResponseApi>) => void;
  readonly datagridRef: MutableRefObject<GridApiPremium>;
  readonly total: number;
  readonly getRowId: (element: CallStatusResourceResponseApi) => string;
  readonly isLoading: boolean;
  readonly shouldDisplayGrid: boolean;
  readonly onPaginationModelChange: (model: GridPaginationModel, details: GridCallbackDetails<'pagination'>) => void;
  readonly onSortModelChange: (sort: GridSortModel, details: GridCallbackDetails) => void;
}) {
  return useMemo<DeviceCallLogsGridProps>(
    () => ({
      handleRowClick,
      total,
      getRowId,
      isLoading,
      shouldDisplayGrid,
      handlePaginationModelChange: onPaginationModelChange,
      handleSortModelChange: onSortModelChange,
      datagridRef,
    }),
    [
      handleRowClick,
      datagridRef,
      total,
      getRowId,
      isLoading,
      shouldDisplayGrid,
      onPaginationModelChange,
      onSortModelChange,
    ],
  );
}
